import { ChangeDetectionStrategy, Component, ComponentRef, OnDestroy, OnInit } from '@angular/core';
import { CartDetailsComponent } from '@spartacus/cart/base/components';
import { CartConfigService } from '@spartacus/cart/base/core';
import {
  ActiveCartFacade,
  Cart,
  MultiCartFacade,
  OrderEntry,
  PromotionLocation,
  SelectiveCartFacade
} from '@spartacus/cart/base/root';
import { AuthService, RoutingService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { fadeIn, fadeOut, rotatedState } from 'src/app/custom/animation/custom-animations';
import { ICON_TYPE } from '../../../../../custom/icons/icon.model';
import { CustomValidateCartService } from '../../../../../services/cart/validate-cart.service';

@Component({
  selector: 'app-custom-cart-details',
  templateUrl: './custom-cart-details.component.html',
  styleUrls: ['./custom-cart-details.component.scss'],
  animations: [fadeIn, fadeOut, rotatedState],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomCartDetailsComponent extends CartDetailsComponent implements OnDestroy, OnInit {
  protected subscriptions: Subscription = new Subscription();
  cart$: Observable<Cart>;
  entries$: Observable<OrderEntry[]>;
  cartLoaded$: Observable<boolean>;
  loggedIn = false;
  entry?: string;
  promotionLocation: PromotionLocation = PromotionLocation.ActiveCart;
  iconTypes = ICON_TYPE;
  selectiveCartEnabled: boolean;
  validatingCart: void | Observable<ComponentRef<any>>;
  showCoupon: boolean;
  state = 'default';
  activeCartZone$ = this.activeCartService.getActive().pipe(map((data) => !!data?.deliveryZone?.code ? data?.deliveryZone : 'continentalEurope'));

  constructor(
    protected activeCartService: ActiveCartFacade,
    protected selectiveCartService: SelectiveCartFacade,
    protected authService: AuthService,
    protected routingService: RoutingService,
    protected cartConfig: CartConfigService,
    protected multiCartService: MultiCartFacade,
    protected customValidateCartService: CustomValidateCartService
  ) {
    super(activeCartService, selectiveCartService, authService, routingService, cartConfig);
  }

  removeCart(cart): void {
    this.multiCartService.deleteCart(cart.code, cart.user.uid);
  }

  clearValidateActions(): void {
    if (this.validatingCart) {
      this.validatingCart
        .subscribe((component) => {
          component.destroy();
        })
        .unsubscribe();
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.clearValidateActions();
  }

  rotate(): void {
    this.state = this.showCoupon ? 'rotated' : 'default';
  }

  showCouponApply(forceDisplay = false): void {
    this.showCoupon = forceDisplay ? true : !this.showCoupon;
    this.rotate();
  }

  remainingAmountForFreeDelivery(cart): number {
    return this.customValidateCartService.remainingAmountForFreeDelivery(cart);
  }

  remainingAmountForFreeDeliveryWithCommas(cart): string {
    const numberValue = this.customValidateCartService.remainingAmountForFreeDelivery(cart).toFixed(2);
    const stringValue = numberValue.toString();
    const finalValue = stringValue.replace('.', ',');

    return finalValue;
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.subscriptions.add(this.activeCartService.getActive().subscribe(cart => {
      if (cart.appliedVouchers?.length) {
        this.showCouponApply(true);
      }
      this.customValidateCartService.unavailableProducts();
      this.subscriptions.add(
        this.customValidateCartService.getProductsModifiedLoading().subscribe(loading => {
          if (!loading) {
            this.entries$ = this.activeCartService
              .getEntries()
              .pipe(filter((entries) => entries.length > 0));
          }
        })
      )
    }));
  }
}
